/* eslint-disable @typescript-eslint/no-unused-vars */
import { View, Text as PDFText } from '@react-pdf/renderer'

import { BookingDetail } from '../../../../../types/bookingDetails'
import { bookingStatus, isCancelledStatus } from '../../../statement'
import { toLocalPhone } from '../../config/functions'
import styles from './stlyes/index.styles'

interface HotelDetailProps {
  data: BookingDetail
}

const HotelDetail = ({ data }: HotelDetailProps) => {
  const {
    accommodationNameTranslatedList,
    propertyAddressFA,
    propertyTelephone
  } = data.basicDetails
  const status = bookingStatus(data.basicDetails)
  const { shortName, name, paymentNumber } = data.sourceInfo

  const channelName = shortName || name

  return (
    <View style={styles.mainDiv}>
      <View style={styles.content}>
        <View style={styles.phoneNumberContainer}>
          <View style={styles.rowDirection2}>
            <PDFText style={styles.subjectTitle}>:تلفن</PDFText>
            <PDFText style={styles.subjectValueNumber}>
              {toLocalPhone(propertyTelephone)}
            </PDFText>
          </View>
          <View style={styles.rowDirection}>
            <PDFText style={styles.subjectTitle}>:نام هتل</PDFText>
            <PDFText style={styles.subjectValue}>
              {accommodationNameTranslatedList[0].value.replace(
                /\(|\)/g,
                ($1) => {
                  return $1 === ')' ? '(' : ')'
                }
              )}
            </PDFText>
          </View>
        </View>
        <View style={styles.phoneNumberContainer}>
          <View style={styles.rowDirection3}>
            <PDFText style={styles.subjectTitle}>:آدرس هتل</PDFText>
            <View style={{ flexDirection: 'row-reverse', flexWrap: 'wrap' }}>
              {propertyAddressFA.split(' ').map((word, index) => (
                <PDFText
                  key={index}
                  style={[styles.subjectValue, { textAlign: 'right' }]}>
                  {word.replace(/\(|\)/g, ($1) => {
                    return $1 === ')' ? '(' : ')'
                  }) + ' '}
                </PDFText>
              ))}
            </View>
          </View>
        </View>
        <View style={styles.phoneNumberContainer}>
          <View style={styles.rowDirection2}>
            <PDFText style={styles.subjectTitle}>:کانال فروش</PDFText>
            <PDFText style={styles.subjectValue}>
              {channelName.replace(/\(|\)/g, ($1) => {
                return $1 === ')' ? '(' : ')'
              })}
            </PDFText>
          </View>
          <View style={styles.rowDirection}>
            <PDFText style={styles.subjectTitle}>:وضعیت رزرو</PDFText>
            <PDFText
              style={
                isCancelledStatus(status)
                  ? styles.subjectValueRed
                  : styles.subjectValue
              }>
              {status}
            </PDFText>
          </View>
        </View>
        <View style={styles.phoneNumberContainer}>
          <View style={styles.rowDirection3}>
            <PDFText style={styles.subjectTitle}>:شماره پرداخت</PDFText>
            <PDFText style={styles.subjectValue}>{paymentNumber}</PDFText>
          </View>
        </View>
      </View>
    </View>
  )
}
export default HotelDetail
